import React from 'react';
import { Context } from "./ContextProvider";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import { withStyles } from '@material-ui/core/styles';
import * as Helpers from "./Helpers";
import * as Consts from "./Consts";
import Tooltip from "@material-ui/core/Tooltip";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { useTranslation } from "react-i18next";
import * as Logger from "./Logger";


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    cell: {
        [theme.breakpoints.down('sm')]: {
            width: "25%",
            padding: '5px 5px 5px 5px',
        },
        [theme.breakpoints.up('md')]: {
            width: '50px',
            padding: '5px 5px 5px 5px',
        },

    },
    rowItiTop: {
        borderTopColor: "gray",
        borderTopStyle: "solid",
    },
    rowIti: {
        // backgroundColor: theme.palette.secondary.main,
        backgroundColor: "gainsboro",
        cursor: "pointer",
        borderCollapse: "collapse",
    },
    rowItiRecomended: {
        backgroundColor: theme.palette.primary.main,
        cursor: "pointer",
        borderCollapse: "collapse",
    },
    selectedRow: {
        borderRightColor: theme.palette.secondary.main,
        borderRightWidth: 10,
        borderRightStyle: "solid",
        cursor: "pointer",
        borderCollapse: "collapse",
    },
    tableContainer: {
        "height": 'calc(70vh - Consts.mobileBarHeight)',
        "martinTop": Consts.mobileBarHeight,
        "overflow":
            "auto",
        "marginTop":
            "100px"
    },
    table: {
        marginTop: Consts.barHeigth + theme.spacing.unit * 2,
    },
    stepRow: {
        borderBottom: "none",
        borderTop: "none",
        cursor: "pointer",
    }
});

function ItinerariesList(props) {
    Logger.log("Rendering ItinerariesList");
    Logger.log("props");
    Logger.log(props);
    const { state, dispatch } = React.useContext(Context);

    const { t, i18n } = useTranslation();

    const [sortDirection, setSortDirection] = React.useState();
    const [sortRow, setSortRow] = React.useState();

    const { classes } = props;
    const { itineraries, selectedLegIndex, selectedItineraryId } = state;

    Logger.log("State");
    Logger.log(state);

    Logger.log(itineraries.plan.itineraries);

    const { efaType } = itineraries.requestParameters;

    function drawIt(iti, index) {
        const itiId = iti.id;
        function handleMouseOverLeg(selectedItiId, legIndex, e) {
            Logger.log("Mouse over iti " + itiId + " and leg " + legIndex);
            if (selectedItiId === itiId) {
                dispatch({ type: "mouseOverLeg", payload: { iti: selectedItiId, leg: legIndex } });
            }
        }

        function handleMouseOutLeg(selectedItiId, legIndex, e) {
            Logger.log("Mouse out iti " + itiId + " and leg " + legIndex);
            dispatch({ type: "mouseOverLeg", payload: undefined })
        }

        function handleItiClick(itiIndex) {
            Logger.log("clicked row with index: " + itiIndex);
            dispatch({ type: "selectIti", payload: itiIndex });
            dispatch({ type: "setAppState", payload: "m" });
        }

        function handleLegClick(selectedItiId, legIndex) {
            Logger.log("clicked row with index: " + selectedItiId);
            dispatch({ type: "selectIti", payload: selectedItiId });
            dispatch({ type: "setAppState", payload: "m" });
            if (state.selectedLegIndex !== legIndex) {
                dispatch({ type: "itiLegDetails", payload: legIndex });
            } else {
                dispatch({ type: "itiLegDetails", payload: undefined });
            }
        }

        function handleStepClick(stepIndex, e) {
            Logger.log("clicked step with index: " + stepIndex);
            if (state.selectedStepIndex !== stepIndex) {
                dispatch({ type: "selectStep", payload: stepIndex });
            } else {
                dispatch({ type: "selectStep", payload: undefined });
            }
        }

        function handleBusStopClick() {
            Logger.log("unsupported ")
        }

        let previousLeg = null;
        let waitTime = 0;


        let itirenaryClasses = iti.recomendedPath ? classes.rowItiRecomended : classes.rowIti;
        itirenaryClasses = itiId === selectedItineraryId ? itirenaryClasses + " " + classes.selectedRow : itirenaryClasses;



        const selectedItirenaryClasses = itiId === selectedItineraryId ? classes.selectedRow : "";

        return (<React.Fragment key={itiId}>
            {state.layoutSize === "s" && <React.Fragment>
                <TableRow colSpan={4} key={itiId}
                    className={itirenaryClasses + " " + classes.rowItiTop}
                    onClick={(e) => handleItiClick(itiId, e)}>
                    <TableCell colSpan={4} className={classes.cell}>
                        <div style={{ float: "left", whiteSpace: "nowrap" }}>
                            <div style={{ marginRight: 2 }}>
                                {Helpers.secondsToTime(iti.startTime)}
                                {iti.legs.map(leg => <img width="20px" height="20px"
                                    src={"./img/modes/" + leg.mode + ".svg"} />)}
                                {Helpers.secondsToTime(iti.endTime)}</div>
                            {iti.walkLimitExceeded && <div>{t("Maximum walk distance exceeded")}</div>}
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow key={itiId}
                    className={itirenaryClasses}
                    onClick={(e) => handleItiClick(itiId, e)}>
                    <TableCell className={classes.cell}>
                        {Helpers.secToMin(iti.duration)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {Helpers.meterToKm(iti.totalDistance)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {iti.fare && Helpers.grToPln(iti.fare.fare.regular.cents)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {Math.round(iti.totalGco2eq)}
                    </TableCell>
                </TableRow>
            </React.Fragment>}
            {(state.layoutSize === "m" || state.layoutSize === "l") &&
                <React.Fragment><TableRow key={itiId}
                    className={itirenaryClasses + " " + classes.rowItiTop}
                    onClick={(e) => handleItiClick(itiId, e)}>
                    <TableCell className={classes.cell}>
                        <div style={{ float: "left", whiteSpace: "nowrap" }}>
                            <div style={{ marginRight: 2 }}>{Helpers.secondsToTime(iti.startTime)}</div>
                            {iti.legs.map(leg => <img width="20px" height="20px"
                                src={"./img/modes/" + leg.mode + ".svg"} />)}
                            <div style={{ marginLeft: 2 }}>{Helpers.secondsToTime(iti.endTime)}</div>
                        </div>
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {Helpers.secToMin(iti.duration)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {Helpers.meterToKm(iti.totalDistance)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {iti.fare && Helpers.grToPln(iti.fare.fare.regular.cents)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {Math.round(iti.totalGco2eq)}
                    </TableCell>
                </TableRow>
                    {iti.walkLimitExceeded && <TableRow key={itiId}
                        className={itirenaryClasses}
                        onClick={(e) => handleItiClick(itiId, e)}>
                        <TableCell colSpan={5} className={classes.cell}>
                            {iti.walkLimitExceeded && <div>{t("Maximum walk distance exceeded")}</div>}
                        </TableCell>
                    </TableRow>}
                </React.Fragment>
            }

            {

                // render only selected itinerary details
                itiId === selectedItineraryId &&
                iti.legs.map((leg, legIndex) => {
                    const icon = "./img/modes/" + leg.mode + ".svg";
                    const isSelecteLeg = legIndex === selectedLegIndex;
                    // calculate wait time if present and if more than minute
                    if (previousLeg) {
                        if ((leg.startTime / 1000 - previousLeg.endTime / 1000) > 60) {
                            waitTime = Helpers.secToMin((leg.startTime - previousLeg.endTime) / 1000);

                        } else {
                            waitTime = 0;
                        }
                    }

                    previousLeg = leg;
                    return (
                        <React.Fragment>
                            {waitTime !== 0 && <TableRow className={selectedItirenaryClasses}>
                                <TableCell className={classes.cell}>{t("Wait")} {waitTime}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>

                            </TableRow>}
                            {state.layoutSize === "s" &&
                                <React.Fragment>
                                    <TableRow  className={selectedItirenaryClasses + " " + classes.stepRow}

                                        key={index + "_" + legIndex}
                                        onClick={(e) => handleLegClick(itiId, legIndex, e)}
                                        onMouseOver={(e) => handleMouseOverLeg(itiId, legIndex, e)}
                                        onMouseOut={(e) => handleMouseOutLeg(itiId, legIndex, e)}>

                                        <TableCell colSpan={4} className={classes.cell+ " " + classes.stepRow}>
                                            {leg.mode === "ELECTRIC" && <Tooltip title={t("Battery start level")}><div>{leg.startChargeLevel} %</div></Tooltip>}
                                            <img src={icon} height="18px" width="18px" />
                                            {leg.mode === "BUS" && "route " + leg.route + ","} {leg.mode !== "STATION" && <React.Fragment>{Helpers.roundTo1Decimal(leg.distance / 1000)} km &nbsp; {t("to")}</React.Fragment>}
                                            <div>{leg.to.name}</div>
                                            {leg.mode === "STATION" && <div>{leg.agencyName}</div>}
                                            {leg.mode === "STATION" && <div><a target="_blank" rel="noopener noreferrer"  href={leg.agencyUrl}>{leg.agencyUrl}</a></div>}
                                            {leg.mode === "ELECTRIC" && <Tooltip title={t("Battery end level")}><div>{leg.endChargeLevel} %</div></Tooltip>}
                                            {leg.rentedElectricCar && <div>{leg.agencyName} <a target="_blank" rel="noopener noreferrer"  href={leg.agencyUrl}>{leg.agencyUrl}</a></div>}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className={selectedItirenaryClasses}>
                                        <TableCell className={classes.cell}>
                                            {Helpers.secToMin(leg.duration)}
                                        </TableCell>
                                        <TableCell className={classes.cell}>
                                            {leg.mode !== "STATION" && Helpers.meterToKm(leg.distance)}
                                        </TableCell>
                                        <TableCell className={classes.cell}>

                                        </TableCell>
                                        <TableCell className={classes.cell}>
                                            {leg.mode !== "WALK" &&
                                                <div>
                                                    {Math.round(leg.gco2eq)}
                                                </div>}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>}
                            {state.layoutSize !== "s" &&
                                <TableRow className={selectedItirenaryClasses}

                                    key={index + "_" + legIndex}
                                    onClick={(e) => handleLegClick(itiId, legIndex, e)}
                                    onMouseOver={(e) => handleMouseOverLeg(itiId, legIndex, e)}
                                    onMouseOut={(e) => handleMouseOutLeg(itiId, legIndex, e)}>

                                    <TableCell className={classes.cell}>
                                        {leg.mode === "ELECTRIC" && <Tooltip title={t("Battery start level")}><div>{leg.startChargeLevel} %</div></Tooltip>}
                                        <img src={icon} height="18px" width="18px" />
                                        {leg.mode === "BUS" && "route " + leg.route + ","} {leg.mode !== "STATION" && <React.Fragment>{Helpers.roundTo1Decimal(leg.distance / 1000)}km &nbsp; {t("to")}</React.Fragment>}
                                        <div>{leg.to.name}</div>
                                        {leg.mode === "STATION" && <div>{leg.agencyName}</div>}
                                        {leg.mode === "STATION" && <div><a target="_blank" rel="noopener noreferrer"  href={leg.agencyUrl}>{leg.agencyUrl}</a></div>}
                                        {leg.mode === "ELECTRIC" && <Tooltip title={t("Battery end level")}><div>{leg.endChargeLevel} %</div></Tooltip>}
                                        {leg.rentedElectricCar && <div>{leg.agencyName} <a target="_blank" rel="noopener noreferrer"  href={leg.agencyUrl}>{leg.agencyUrl}</a></div>}
                                    </TableCell>

                                    <TableCell className={classes.cell}>
                                        {Helpers.secToMin(leg.duration)}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {leg.mode !== "STATION" && Helpers.meterToKm(leg.distance)}
                                    </TableCell>
                                    <TableCell className={classes.cell}>

                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {leg.mode !== "WALK" &&
                                            <div>
                                                {Math.round(leg.gco2eq)}
                                            </div>}
                                    </TableCell>
                                </TableRow>}
                            {isSelecteLeg && leg.mode === "BUS" &&
                                <React.Fragment>
                                    <TableRow className={classes.stepRow}
                                        onClick={(e) => handleStepClick("from", e)}>
                                        <TableCell className={classes.stepRow} colSpan={5}>
                                            {Helpers.secondsToTime(leg.from.departure)} {leg.from.name}
                                        </TableCell>
                                    </TableRow>
                                    < TableRow className={classes.stepRow}
                                        onClick={(e) => handleStepClick("to", e)}>
                                        <TableCell className={classes.stepRow} colSpan={5}>
                                            {Helpers.secondsToTime(leg.to.arrival)} {leg.to.name}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>}
                            {isSelecteLeg && leg.mode !== "BUS" && leg.steps.map((step, stepIndex) => {
                                const distanceJed = step.distance < 1000 ? "m" : "km";
                                const distance = step.distance < 1000 ? Helpers.roundTo0Decimal(step.distance) : Helpers.roundTo1Decimal(step.distance / 1000);
                                const stepIconPath = "./img/directions/" + step.relativeDirection + ".svg";
                                return <TableRow className={classes.stepRow}
                                    onClick={(e) => handleStepClick(stepIndex, e)}>
                                    <TableCell className={classes.stepRow} colSpan={4}>
                                        <img alt={step.relativeDirection} title={step.relativeDirection}
                                            src={stepIconPath} width="18px" height="18px" />&nbsp;
                                                {t("to")} {step.streetName}, {distance} {distanceJed}
                                    </TableCell>
                                </TableRow>;
                            })
                            }
                        </React.Fragment>
                    );
                }
                )
            }
        </React.Fragment>
        );
    }

    function sortItis(itineraries, weightOptimization) {
        if(sortRow === undefined){
            // this is the first sort after query result, no sort button clicked
            switch(weightOptimization) {
              case "QUICKER":
                itineraries.sort((a, b) => {
                    let p = a.duration - b.duration;
                    p = sortDirection === "asc" ? p : -p;
                    return p
                })
                break;
              case "SHORTER":
                itineraries.sort((a, b) => {
                    let p = a.totalDistance - b.totalDistance;
                    p = sortDirection === "asc" ? p : -p;
                    return p
                })
                break;
              case "GREENER":
                itineraries.sort((a, b) => {
                    let p = a.totalGco2eq - b.totalGco2eq;
                    p = sortDirection === "asc" ? p : -p;
                    return p
                })
                break;
              default:
                // "CHEAPER"
                itineraries.sort((a, b) => {
                    let afare = a.fare ? a.fare.fare.regular.cents : 0;
                    let bfare = b.fare ? b.fare.fare.regular.cents : 0;
                    let p = afare - bfare;
                    p = sortDirection === "asc" ? p : -p;
                    return p
                })
            }
            return itineraries
        }


        if (sortRow === t("Dist")) {
            itineraries.sort((a, b) => {
                let p = a.totalDistance - b.totalDistance;
                p = sortDirection === "asc" ? p : -p;
                return p
            })
        } else if(sortRow === t("Time")) {
            itineraries.sort((a, b) => {
                let p = a.duration - b.duration;
                p = sortDirection === "asc" ? p : -p;
                return p
            })
        } else if(sortRow === "gCO2eq [gCO2]") {
            itineraries.sort((a, b) => {
                let p = a.totalGco2eq - b.totalGco2eq;
                p = sortDirection === "asc" ? p : -p;
                return p
            })
        } else {
            itineraries.sort((a, b) => {
                let afare = a.fare ? a.fare.fare.regular.cents : 0;
                let bfare = b.fare ? b.fare.fare.regular.cents : 0;
                let p = afare - bfare;
                p = sortDirection === "asc" ? p : -p;
                return p
            })
        }

        return itineraries;
    }

    function handleRowClick(rowName) {
        setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        setSortRow(rowName);
    }

    function createHeaderRow(name) {
        return <TableCell className={classes.cell}
            sortDirection={sortDirection === name ? sortDirection : false}
        >
            <Tooltip
                title="Sort"
                placement={'top-start'}
                enterDelay={300}
            >
                <TableSortLabel
                    active={sortRow === name}
                    direction={sortDirection}
                    onClick={() => handleRowClick(name)}
                >
                    {name}
                </TableSortLabel>
            </Tooltip>
        </TableCell>
    }

    return <div className={classes.tableContainer}>
        <Table style={{ "borderCollapse": "collapse" }} stickyHeader aria-label="sticky table">
            <TableHead>
                {state.layoutSize === "s" && <TableRow>
                    {state.layoutSize !== "s" && <TableCell>{t("Mode")}</TableCell>}
                </TableRow>}
                <TableRow>
                    {state.layoutSize !== "s" && <TableCell>{t("Mode")}</TableCell>}
                    {createHeaderRow(t("Time"))}
                    {createHeaderRow(t("Dist"))}
                    {createHeaderRow(t("Cost") + " [" + state.metadata.currencyType + "]")}
                    {createHeaderRow("gCO2eq [gCO2]")}
                </TableRow>
            </TableHead>
            <TableBody>
                {sortItis(itineraries.plan.itineraries, itineraries.plan.weightOptimization).map((iti, index) => drawIt(iti, index))}
            </TableBody>
        </Table>
    </div>
}


export default withStyles(styles)(ItinerariesList);


